import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-emailgroups',
  templateUrl: './emailgroups.component.html',
  styleUrls: ['./emailgroups.component.css']
})
export class EmailgroupsComponent implements OnInit {

  status:number=0;
  edit:any;
  button:string='save';
  headertitle:string='Add';
  submitted:boolean=false;

  form = new FormGroup({
    name: new FormControl('',[Validators.required]),
    status:new FormControl('0')
  });

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,private dialogRef: MatDialogRef<EmailgroupsComponent>) { }

  ngOnInit() {
    console.log(this.data);
    this.edit=this.data.edit;
    if(this.data.edit>0)
      this.edit=this.data.edit;
    else
    this.edit='';

    if(this.data.data!='')
      this.formpatch(this.data.data)
    
  }

  onchange(e:any){
    if(e.checked==true){
      this.form.patchValue({
        status:1
      })
    }else{
      this.form.patchValue({
        status:0
      })
    }
    console.log("form value ::::",this.form.value);
  }
  formpatch(data:any){
    this.status=data.status;
    this.form.patchValue({
      name:data.name,
      status:data.status
    })
  }
  onSubmitgroup(){
    this.submitted=true
    console.log(this.form.invalid);
    if (this.form.invalid) {
        this.submitted=true
        return;
    }else{
      // this.dialogRef.close(this.form.value)
      this.close()
    }

  }

  close(){
    this.dialogRef.close({formdata:this.form.value,id:this.data.data.id,isaction:1});
   }

   onclose(){
      this.dialogRef.close({formdata:this.form.value,id:this.data.data.id,isaction:0});
   }

}
